module.exports = __webpack_public_path__ + "img/client_sea.d917e298.png";